import React from 'react';

import Theme from 'styles/theme';

const GiftIcon = () => (
  <div className="GiftIcon">
    <svg width="22" height="24" viewBox="0 0 22 24" xmlns="http://www.w3.org/2000/svg">
      <g fill="none">
        <g id="Gift-Messaging" transform="translate(-873 -711)">
          <g transform="translate(874 712)">
            <polygon id="Stroke-1" stroke="#1F2A30" points="1 22 19 22 19 7 1 7" />
            <polygon id="Fill-3" fill="#FFF" points="0 11 19 11 19 7 0 7" />
            <g stroke="#1F2A30">
              <polygon
                id="Stroke-4"
                points="0.428571429 10.4206667 19.6009524 10.4206667 19.6009524 6.22691667 0.428571429 6.22691667"
              />
              <path
                d="M13.9539048,0.645058333 C10.8891429,-1.284525 9.36247619,6.137725 10.3748571,6.22480833 C11.3862857,6.31280833 16.7577143,2.41055833 13.9539048,0.645058333 Z"
                id="Stroke-6"
              />
              <path
                d="M6.07533333,0.645058333 C9.14009524,-1.284525 10.6667619,6.137725 9.65438095,6.22480833 C8.64295238,6.31280833 3.27152381,2.41055833 6.07533333,0.645058333 Z"
                id="Stroke-7"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>

    <style jsx>
      {`
        .GiftIcon {
          display: inline-block;
          vertical-align: middle;
          margin: 0 ${Theme.get('spacing') * 2}px;
        }
      `}
    </style>
  </div>
);

export default GiftIcon;
